// extracted by css-extract-rspack-plugin
export default {"ruleRow":"syTzhuzxbA8WDlp5","ruleInputs":"tRJWay7eCz0uFej2","numberInputWrapper":"gapCvInQvnsEljTQ","selectWrapper":"jwwKLL_XkcA1hFLQ"};